import {
  EHeadingStyleVariant,
  ETextStyleVariant,
  GeneralArrowRightIcon,
  Grid,
  GridItem,
  Heading,
  Text,
} from '@outdoorsyco/bonfire';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import Link from '@/components/switchback/Link/Link';
import ResponsiveImage from '@/components/utility/ResponsiveImage/ResponsiveImage';
import { ESearchFilters } from '@/constants/searchFilters';
import { useBreakpoint } from '@/hooks/useBreakpoint';
import { TPopularUpcomingDates } from '@/hooks/usePopularUpcomingDates';

type TPopularCardProps = TPopularUpcomingDates & { address: string };

export const PopularCard = ({
  title,
  image,
  dates,
  active_listing_count,
  booking_count,
  address,
}: TPopularCardProps) => {
  const { isAboveDesktop } = useBreakpoint();
  const percentage = Math.round((booking_count / active_listing_count) * 100);

  const params = {
    [ESearchFilters.ADDRESS]: address,
    [ESearchFilters.DATE_FROM]: dates.from,
    [ESearchFilters.DATE_TO]: dates.to,
  };

  const searchParams = new URLSearchParams(params).toString();
  const target = isAboveDesktop ? '_blank' : undefined;

  return (
    <Link href={`/rv-search?${searchParams}`} legacy forceClientsideRouting target={target}>
      <Grid className="w-full h-full bg-white rounded-2xl group transition-all duration-200">
        <GridItem xs={4} sm={3} md={4} lg={3}>
          <ResponsiveImage
            src={image}
            alt={title}
            className="object-cover object-top w-full h-full rounded-l-2xl max-h-[142px]"
          />
        </GridItem>
        <GridItem xs={8} sm={9} md={8} lg={9}>
          <div className="flex flex-col p-4 gap-2">
            <Heading variant={EHeadingStyleVariant.H3} className="text-xl font-medium truncate">
              {title}
            </Heading>
            <Text component="p" variant={ETextStyleVariant.SmallRegular} className="line-clamp-2">
              <FormattedMessage
                defaultMessage="{percentage}% of RVs are booked around {holiday}. Book yours now."
                description="Home > Popular upcoming dates > Popular card"
                id="8BNcok"
                values={{
                  holiday: title,
                  percentage,
                }}
              />
            </Text>
            <div className="flex flex-row items-center truncate gap-2">
              <Text variant={ETextStyleVariant.MediumRegular}>
                <FormattedMessage
                  defaultMessage="See RVs near you"
                  description="Home > Popular upcoming dates > Popular card"
                  id="kl32uA"
                />
              </Text>
              <GeneralArrowRightIcon className="transition-transform duration-200 ease-in-out group-hover:translate-x-1" />
            </div>
          </div>
        </GridItem>
      </Grid>
    </Link>
  );
};
